<template>
  <div :class="groupClass">
    <label :class="lableClass" :for="name">
      <slot>{{ title }}</slot>
    </label>

    <div :class="fieldClass">
      <!--Special Part Starts-->
      <el-time-select
        v-model="value"
        :picker-options="{
          start: start,
          step: step,
          end: end,
        }"
        :placeholder="placeholder ? placeholder : 'Select time'"
        @blur="blur"
        @change="change"
      />
      <!--Special Part Ends-->

      <div
        v-if="form && form.errors.has(errorId)"
        class="invalid-feedback"
        v-text="form.errors.get(errorId)"
      ></div>
      <slot name="note"></slot>
    </div>

    <div :class="extraSlotClass">
      <slot name="extra"></slot>
    </div>
  </div>
</template>

<script type="text/babel">
import BaseComponent from "./BaseComponent.vue";

export default {
  extends: BaseComponent,

  props: {
    start: {
      default: "00:00",
    },
    end: {
      default: "23:30",
    },
    step: {
      default: "00:30",
    },
  },

  methods: {
    change(value) {
      this.$emit("input", value);
      this.$emit("change", value);

      if (this.form) {
        this.form.errors.clear(this.errorId);
      }
    },

    blur(value) {
      if (value.userInput && value.userInput.length > 0) {
        /* eslint-disable no-param-reassign */
        value.userInput = null;

        window.toastr.warning(
          "Custom input for Time field is not allowed, reverting to previous value.",
          "Warning"
        );
      }
    },
  },
};
</script>
